@use 'themes/westfield' as *;
@use 'tools/dirg' as *;
@use 'tools/dirg-breakpoint' as *;

.intro.intro {
  padding: units(1) 0 units(1.5);
  border-top: #a2a2a9 solid 1px;
  color: #1c1f24;

  @include fromBreakpoint(tablet) {
    padding: units(1.5) 0;
  }
}

.email {
  font-weight: bold;
}
